<template>
    <div>
        <div class="flex center-xs space-top-1 space-bottom-2"></div>

        <ButtonSection
          :inputValid="inputValid"
          :order="order"
          :buttonText="step.buttonText"
          v-on:progress="$emit('progress')"
          v-on:back="$emit('back')"
        />
    </div>
</template>

<script>
import ButtonSection from '../components/ButtonSection';

export default {
    props: ['step', 'order'],
    data() {
        return {
            inputValid: true
        }
    },
    components: {
        ButtonSection
    }
}
</script>
